import React from "react";
import { Route, Switch } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import TiendaOnlineRoute from "./TiendaOnlineRoute";

import { Login, Registro } from "./common/components/LoginRegister";
import Home from "./common/components/Home";
import Pago from "./common/components/Pago/index";
import EstadoCompra from "./common/components/EstadoCompra/index";
import ListadoProductos from "./common/components/ListadoProductos";
import DetalleProductos from "./common/components/DetalleProducto";
import Perfil from "./common/components/Perfil";
import CompletarPerfil from "./common/components/CompletarPerfil";

import NotFound from "./common/components/layout/NotFound/NotFound";

import "../assets/fonts/fonts.css";
import "bootstrap/dist/css/bootstrap.min.css";

require("../../node_modules/font-awesome/css/font-awesome.css");
require("../../node_modules/bootstrap/dist/css/bootstrap.css");
require("../style/index.css");

// Componente para setear el scroll hasta la parte superior de cada pagina
import ScrollToTop from "./ScrollToTop";

module.exports = (
    <div>
        <ScrollToTop />
        <div className="container__content">
            <Switch>
                {/* <TiendaOnlineRoute exact path="/login" component={Login} />
                <TiendaOnlineRoute exact path="/register" component={Registro} />
                <TiendaOnlineRoute exact path="/perfil" component={Perfil} />
                <TiendaOnlineRoute exact path="/completar-perfil" component={CompletarPerfil} /> */}
                <TiendaOnlineRoute
                    exact
                    path="/"
                    component={Home}
                    vista="home"
                />
                <Route
                    exact
                    path="/estado_compra/:codigo"
                    component={EstadoCompra}
                />
                <TiendaOnlineRoute
                    exact
                    path="/tienda/:slug_empresa/pago"
                    component={Pago}
                    mostrar_iconos={true}
                />
                <TiendaOnlineRoute
                    path="/tienda/:slug_empresa/"
                    component={ListadoProductos}
                    buscador_tienda={true}
                    mostrar_iconos={true}
                    vista="tienda"
                />
                <TiendaOnlineRoute
                    exact
                    path="/producto/:slug_producto/"
                    component={DetalleProductos}
                    mostrar_iconos={true}
                />
                <Route component={NotFound} />
            </Switch>
        </div>
        <NotificationContainer />
    </div>
);
